import React from 'react';
import PropTypes from 'prop-types';
import { TableRowColumn } from 'material-ui/Table';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const SelectInputTableCell = (props) => {
    const {
        choices,
        name,
        onChangeInput,
        optionText,
        optionValue,
        style,
        value,
    } = props;

    return (
        <TableRowColumn style={ style }>
            <SelectField
                id={ value.id ? `${ value.id }` : '' }
                name={ name }
                onChange={ (event, index, menuItemValue) => {
                    event.persist();

                    event.target.name = name;
                    event.target.value = menuItemValue;

                    return onChangeInput(event, value);
                } }
                style={ {
                    height: (style.height || 48) + 4,
                } }
                value={ value[name] || null }
            >
                {
                    choices.map((choice) => {
                        let checked = null;

                        if (choice[optionValue]) {
                            checked = value[name] == choice[optionValue];
                        }

                        return (
                            <MenuItem
                                key={ `${ name }-choice-${ choice[optionValue] }` }
                                checked={ checked }
                                primaryText={ choice[optionText] }
                                value={ choice[optionValue] }
                            />
                        );
                    })
                }
            </SelectField>
        </TableRowColumn>
    );
};

SelectInputTableCell.defaultProps = {
    choices: [],
    name: 'selectInputTableCell',
    onChangeInput: () => {},
    optionText: 'text',
    optionValue: 'value',
    value: {},
};

SelectInputTableCell.propTypes = {
    choices: PropTypes.arrayOf(PropTypes.object),
    optionText: PropTypes.string,
    optionValue: PropTypes.string,
    name: PropTypes.string,
    onChangeInput: PropTypes.func,
    style: PropTypes.object,
    value: PropTypes.object,
};

export default SelectInputTableCell;


// WEBPACK FOOTER //
// ./src/pages/products/configuration/SelectInputTableCell.js